/** Table K (part 18): which importer a picked file goes to, by its name; none for anything else (K3). */
import type { ImportFormat } from '@cockatrice/core';

/** A kind a writer picks a file of: not a bundle (part 24's). */
export type PickedKind = Exclude<ImportFormat, 'bundle'>;

/** K1, K2: the endings each kind takes, lower case. */
const ENDINGS: readonly (readonly [string, PickedKind])[] = [
  ['.md', 'markdown'],
  ['.markdown', 'markdown'],
  ['.mdown', 'markdown'],
  ['.mkd', 'markdown'],
  ['.txt', 'text'],
  ['.docx', 'docx'],
  ['.docm', 'docx'],
  ['.dotx', 'docx'],
  ['.dotm', 'docx'],
];

/** What the file input accepts (K1, K2). */
export const IMPORT_ACCEPT = ENDINGS.map(([ending]) => ending).join(',');

/** Part 23b, V′1: what Re-import DOCX…'s file input accepts: the Word endings of K2. */
export const DOCX_ACCEPT = ENDINGS.flatMap(([ending, kind]) => (kind === 'docx' ? [ending] : [])).join(',');

/** K1–K3: the kind of a file named `name`, or null. */
export function importKind(name: string): PickedKind | null {
  const lower = name.toLowerCase();
  for (const [ending, kind] of ENDINGS) if (lower.endsWith(ending)) return kind;
  return null;
}

/** C5: a file's name without its ending, the book's title when the file gives none. */
export function nameTitle(name: string): string {
  const dot = name.lastIndexOf('.');
  return (dot > 0 ? name.slice(0, dot) : name).trim();
}
